import registerComponents from '@/utils/registerComponents';

const requireComponent = require.context(
  '.',
  true,
  /Base[\w-]+\.vue$/,
);

registerComponents(requireComponent);
